
type ColorPalette = {
  title: string,
  subtitle: string,
  colors: ColorGroup
}

type ColorGroup = {
  [key: string] : Color
}

type Color = string;

const colorSource : ColorPalette[] = [
  {
    title: 'Primary color palette',
    subtitle: 'The primary palette is comprised of our neutral colors.',
    colors: {
      black: `#171719`,
      night: `#2d282b`,
      grey: `#444344`,
      mediumGrey: `#797477`,
      lightGrey: `#9e979b`,
      stone: `#c4bcc0`,
      smoke: `#eae5e7`,
      ghostWhite: `#f4f2f3`,
      fog: `#f9f8f9`,
      snow: `#ffffff`,
    },
  },
  {
    title: 'Secondary color palette',
    subtitle: 'The secondary palette is used to add (something here). Use no more than 3 secondary colors at a time.',
    colors: {
      blue: `#145cc6`,
      darkBlue: `#00308E`,
      lightBlue: `#a7c5ea`,
      darkPink: `#ff9f9f`,
      pink: `#ffbdbb`,
      lightPink: `#ffd9d9`,
      carrot: `#dd5d05`,
      orange: `#ff7b22`,
      yellow: `#eda900`,
      sunglow: `#fcc938`,
      red: `#fb3728`,
      disco: `#6d144f`,
      wine: `#8e166c`,
      hotPink: `#e04aa5`,
      parsley: `#1f5e19`,
      candyGreen: `#289b3f`,
      pastelGreen: `#71db82`,
      java: `#23b7b7`,
      aqua: `#7bd8db`,
    }
  },
  {
    title: 'Social media colors',
    subtitle: 'These correspond to social networks\' brand colors, and are used only in the context of social share buttons.',
    colors: {
      facebook: `#4267B2`,
      twitter: `#1DA1F2`,
      linkedin: `#2867B2`,
    }
  },
  {
    title: 'Upsun colors',
    subtitle: 'Upsun colors',
    colors: {
      neutralWhite: `#ffffff`,
      neutral300: `#e1e3e4`,
      neutral400: `#b4babd`,
      neutral500: `#899296`,
      neutral600: `#98a0ab`,
      neutral800: `#2b3134`,
      neutral900: `#191c1e`,
      neutral1000: `#0e1113`,
      black1000: `#0c0f10`,
      black200: `#d8dbdc`,
      black300: `#b1b7ba`,
      black400: `#889397`,
      black500: `#646F75`,
      black600: `#3d4b52`,
      black700: `#252d31`,
      black800: `#252D31`,
      black900: `#181e21`,
      violet100: `#EFEDFF`,
      violet200: `#dfdaff`,
      violet300: `#bfb5ff`,
      violet400: `#a090ff`,
      violet500: `#806bff`,
      violet600: `#6046ff`,
      violet900: `#261c66`,
      orange500: `#ff6e41`,
      orange600: `#ff4a11`,
      pink100: `#fde8fd`,
      pink500: `#ed49f0`,
      yellow500: `#ddf933`,
      yellow600: `#d5f800`,
      skyblue400: `#66e3f4`,
      lime300: `#eefc99`,
      lime400: `#e6fb66`,
      lime500: `#ddf933`,
      lime600: `#d5f800`,
      lime700: `#aac600`,
      white: `#ffffff`,
      borderDefault: `#646F75`
    }
  }
];

export const colors : ColorGroup = {};

colorSource.forEach((colorGroup) => {
  const colorSlugs = Object.keys(colorGroup.colors);

  colorSlugs.forEach(slug => {
    colors[slug] = colorGroup.colors[slug];
  });
});
